import { gql, useMutation } from "@apollo/client";
import { cartVar } from "./useCart";

export type AddCouponInput = {
	cartId: string,
	coupon: {
		name: string,
	},
}

const ADD_COUPON = gql`
  mutation CartAddCoupon($input: Cart_AddCouponInput!) {
    Cart_addCoupon(input: $input) {
        id
        customerCode
        industryCode
        status
        code
        userId
				grossPrice
				netPrice
				valid
				discountValue
				coupons
				shippingOrders {
					code
					paymentTerm
				}
				items {
					code
					amount
					totalDiscount
					commercialPolicyId
					type
					valid
					unitGrossPrice
					unitNetPrice
					grossPrice
					netPrice
					discountValue
					discount
					errors {
						type
						message
					}
					discountsTrace
					coupons {
						name
						percentage
					}
          		product {
						code
						description
						brand {
							id
							description
						}
						assortment {
							name
						}
					}
					suggestions{
						list{
							name
							code
							amount
						}
						anchor {
							anchorAmount
						}
					}
				}
    }
  }
`;

export const useAddCoupon = () => {
	return useMutation(ADD_COUPON, {
		refetchQueries: [
		],
		onCompleted(data) {
			if (data.Cart_addCoupon) {
				cartVar(data.Cart_addCoupon)
			}
		},
	});
};
